module.exports = __webpack_public_path__ + "img/user_center_nodata.d809e364.png";